/** Проверка «это jQuery-объект» без опоры на конкретный экземпляр jQuery (Kendo отдаёт поле именно так). */
export function isJQueryInstance(value: unknown): value is JQuery {
    return Boolean(value) && typeof (value as { jquery?: unknown }).jquery === 'string';
}
